import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ words, dark = false }) => (
  <div className={`py-10 overflow-hidden border-y ${dark ? "border-white/10 bg-olime-ink" : "border-olime-line bg-olime-bg"}`}>
    <Marquee speed={38} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-serif italic text-4xl md:text-6xl px-8 ${dark ? "text-white" : "text-olime-ink"}`}>{w}</span>
          <span className="text-olime-sand text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
